export default __webpack_public_path__ + "static/media/desk-clean-img2.3953924a.png";